import { FEED_COMMENTS_I18N_KEYS } from '../../../../../features/home/components/constants/i18n/FeedCommentsi18nConstants';

export const FEED_COMMENTS_I18N_EN =  {
  [FEED_COMMENTS_I18N_KEYS.constructive_label]:      "Constructive ({{constructivenessScore}}%)",
  [FEED_COMMENTS_I18N_KEYS.not_constructive_label]:  "Not constructive ({{constructivenessScore}}%)",
  [FEED_COMMENTS_I18N_KEYS.constructive_hover_text]: "Constructiveness Score: {{constructivenessScore}}%"
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/feed_comments.i18n.en.js